const API_BASE_URL = process.env.BASE_URL

export const CRM_ENDPOINTS = {
    CONNECTION: API_BASE_URL + "/integrations/apideck/crm/connection/",
    CONFIG: API_BASE_URL + "/integrations/apideck/crm/config/",
    VAULT_AUTHORIZE: API_BASE_URL + "/integrations/apideck/vault/crm/",
}
